import makeStyles from '@mui/styles/makeStyles';

const headerMenuSurface = (theme) => ({
    border: "1px solid var(--atl-border) !important",
    background: "transparent",
    boxShadow: theme.palette.mode === "light"
        ? "0 18px 46px rgba(28, 54, 78, 0.14) !important"
        : "0 22px 58px rgba(0, 0, 0, 0.46) !important",
    backdropFilter: "blur(18px) saturate(155%)",
    WebkitBackdropFilter: "blur(18px) saturate(155%)",
});

export const HeaderStyle = makeStyles((theme) => ({
    root: {
        marginBottom: 0,
    },
    appbar: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: theme.zIndex.drawer + 10,
        color: "var(--atl-text)",
        background: "linear-gradient(180deg, color-mix(in srgb, var(--atl-header) 84%, transparent) 0%, color-mix(in srgb, var(--atl-header) 68%, transparent) 100%)",
        borderRadius: 0,
        borderBottom: "1px solid var(--atl-header-border)",
        boxShadow: "0 10px 32px rgba(28, 54, 78, 0.1), inset 0 1px 0 rgba(255,255,255,0.24)",
        backdropFilter: "blur(28px) saturate(190%)",
        WebkitBackdropFilter: "blur(28px) saturate(190%)",
    },
    toolbar: {
        minHeight: "64px !important",
        display: "grid",
        gridTemplateColumns: "auto minmax(0, 1fr) auto",
        gap: 12,
        padding: theme.spacing(0, 2),
        [theme.breakpoints.down('sm')]: {
            minHeight: "58px !important",
            gap: 8,
            padding: theme.spacing(0, 1),
        },
    },
    toolbarOffset: {
        minHeight: 64,
        [theme.breakpoints.down('sm')]: {
            minHeight: 58,
        },
    },
    brandZone: {
        display: "inline-flex",
        alignItems: "center",
        gap: 10,
        minWidth: 0,
    },
    backButton: {
        color: "var(--atl-text)",
    },
    brandButton: {
        display: "inline-flex",
        alignItems: "center",
        gap: 10,
        height: 44,
        padding: theme.spacing(0, 1.5, 0, 0.75),
        font: "inherit",
        appearance: "none",
        WebkitAppearance: "none",
        border: "1px solid var(--atl-border)",
        borderRadius: 12,
        color: "var(--atl-text)",
        background: "linear-gradient(180deg, var(--atl-surface-strong) 0%, var(--atl-surface) 100%)",
        boxShadow: "var(--atl-shadow)",
        cursor: "pointer",
        transition: "transform 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease",
        "&:hover": {
            transform: "translateY(-1px)",
            borderColor: "var(--atl-border-strong)",
            boxShadow: "var(--atl-shadow-strong)",
        },
        [theme.breakpoints.down('sm')]: {
            paddingRight: theme.spacing(0.75),
        },
    },
    logo: {
        width: 34,
        height: 34,
        objectFit: "contain",
    },
    brandCopy: {
        display: "flex",
        flexDirection: "column",
        lineHeight: 1,
        [theme.breakpoints.down('md')]: {
            display: "none",
        },
    },
    brandName: {
        color: "var(--atl-text)",
        fontSize: 14,
        fontWeight: 900,
        letterSpacing: 0,
    },
    brandMeta: {
        color: "var(--atl-text-muted)",
        fontSize: 11,
        fontWeight: 800,
        letterSpacing: "0.02em",
        textTransform: "uppercase",
    },
    managerTitle: {
        minWidth: 0,
        overflow: "hidden",
        color: "var(--atl-text)",
        fontSize: 18,
        fontWeight: 900,
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        [theme.breakpoints.down('sm')]: {
            fontSize: 15,
        },
    },
    actionCluster: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "flex-end",
        gap: 6,
    },
    iconButton: {
        width: 42,
        height: 42,
        color: "var(--atl-text)",
        border: "1px solid transparent",
        "&:hover": {
            borderColor: "var(--atl-border)",
        },
        [theme.breakpoints.down('sm')]: {
            width: 38,
            height: 38,
        },
    },
    appsButton: {
        width: 42,
        height: 42,
        color: "#fff",
        background: "linear-gradient(135deg, var(--atl-blue) 0%, var(--atl-teal) 100%)",
        boxShadow: "0 10px 24px rgba(48, 79, 254, 0.24)",
        "&:hover": {
            background: "linear-gradient(135deg, var(--atl-blue-dark) 0%, var(--atl-teal) 100%)",
        },
        [theme.breakpoints.down('sm')]: {
            width: 38,
            height: 38,
        },
    },
    profileButton: {
        padding: 3,
        border: "1px solid var(--atl-border)",
        background: "var(--atl-surface-muted)",
    },
    avatarSmall: {
        width: 34,
        height: 34,
        background: "transparent",
        [theme.breakpoints.down('sm')]: {
            width: 30,
            height: 30,
        },
    },
    appsMenuPaper: {
        ...headerMenuSurface(theme),
        width: 380,
        maxWidth: "calc(100vw - 24px)",
        marginTop: 10,
        padding: 0,
        borderRadius: "22px !important",
        overflow: "hidden",
    },
    appsPanel: {
        padding: theme.spacing(2),
        background: "transparent",
    },
    appsHeader: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        gap: 12,
        marginBottom: 12,
    },
    appsEyebrow: {
        color: "var(--atl-text-muted)",
        fontSize: 11,
        fontWeight: 900,
        letterSpacing: "0.08em",
        textTransform: "uppercase",
    },
    appsTitle: {
        color: "var(--atl-text)",
        fontSize: 18,
        fontWeight: 900,
        lineHeight: 1.15,
    },
    appsSection: {
        paddingTop: 12,
        "& + &": {
            marginTop: 12,
            borderTop: "1px solid var(--atl-border)",
        },
    },
    appsSectionTitle: {
        marginBottom: 8,
        color: "var(--atl-text-soft)",
        fontSize: 12,
        fontWeight: 900,
        letterSpacing: "0.04em",
        textTransform: "uppercase",
    },
    appsGrid: {
        display: "grid",
        gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
        gap: 8,
        [theme.breakpoints.down('xs')]: {
            gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
        },
    },
    appTile: {
        display: "grid",
        gridTemplateRows: "42px auto",
        justifyItems: "center",
        alignItems: "start",
        gap: 8,
        minHeight: 112,
        padding: 10,
        border: "1px solid transparent",
        borderRadius: 16,
        color: "var(--atl-text)",
        background: "transparent",
        cursor: "pointer",
        transition: "transform 0.18s ease, background-color 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease",
        "&:hover": {
            transform: "translateY(-2px)",
            borderColor: "var(--tile-color)",
            background: "var(--atl-surface-muted)",
            boxShadow: "0 14px 34px color-mix(in srgb, var(--tile-color) 18%, transparent)",
        },
    },
    appTileIcon: {
        display: "inline-grid",
        placeItems: "center",
        width: 42,
        height: 42,
        borderRadius: 14,
        color: "#fff",
        boxShadow: "0 8px 18px color-mix(in srgb, var(--tile-color) 28%, transparent)",
        background: "linear-gradient(135deg, var(--tile-color) 0%, var(--tile-color-2) 100%)",
        "& svg": {
            width: 22,
            height: 22,
        },
    },
    appTileCopy: {
        display: "grid",
        justifyItems: "center",
        width: "100%",
        textAlign: "center",
    },
    appTileTitle: {
        color: "var(--atl-text)",
        fontSize: 12,
        fontWeight: 900,
        lineHeight: 1.15,
        textAlign: "center",
    },
    appTileDescription: {
        marginTop: 3,
        color: "var(--atl-text-muted)",
        fontSize: 11,
        fontWeight: 650,
        lineHeight: 1.2,
        textAlign: "center",
    },
    menu: {
        width: 288,
    },
    profileMenuPaper: {
        ...headerMenuSurface(theme),
        width: 300,
        marginTop: 10,
        padding: theme.spacing(1),
        borderRadius: "22px !important",
        overflow: "hidden",
    },
    profileHeader: {
        display: "grid",
        justifyItems: "center",
        gap: 8,
        padding: theme.spacing(2, 1.5),
        borderRadius: 18,
        background: "var(--atl-surface-muted)",
    },
    large: {
        width: theme.spacing(7),
        height: theme.spacing(7),
        background: "transparent",
    },
    profileName: {
        color: "var(--atl-text)",
        fontWeight: 900,
        textAlign: "center",
    },
    profileMeta: {
        color: "var(--atl-text-soft)",
        fontSize: 13,
        fontWeight: 700,
        textAlign: "center",
    },
    profileMenuItem: {
        minHeight: 44,
        borderRadius: 12,
        marginTop: 4,
        fontWeight: 800,
        "&:hover": {
            background: "color-mix(in srgb, var(--atl-blue) 10%, transparent)",
        },
    },
    tooltip: {
        marginTop: -50,
    },
    subtextModule: {
        color: "var(--atl-text-soft)",
        margin: theme.spacing(2, 10, 0, 10),
        [theme.breakpoints.down('md')]: {
            margin: theme.spacing(1, 0.5, 0, 0.5),
            fontSize: "0.875rem",
        },
    },
    title: {
        marginTop: theme.spacing(1),
    },
    titleMain: {
        marginTop: theme.spacing(1),
        color: "var(--atl-text)"
    },
    managerTitleShort: {
        [theme.breakpoints.up('xs')]: {
            display: "none",
        },
        [theme.breakpoints.down('sm')]: {
            flexGrow: 1,
            fontFamily: "Montserrat Alternates",
            display: "inherit",
        },
    },
    langButton: {
        color: "var(--atl-text)"
    }
}));
